import state from "./employeeState.js";
import mutations from "./employeeMutations.js";
import actions from "./employeeAction.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  // getters,
};